import {
  BackgroundModule,
  FlexboxModule,
  GridModule,
  SpacingModule,
  PaddingModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PageSectionComponent } from './page-section.component';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { IntroSectionModule } from './intro-section/intro-section.module';
import { CarouselSectionModule } from './carousel-section/carousel-section.module';
import { IndexCardsModule } from '@marketing/index-cards/index-cards.module';
import { MediaCardsSectionModule } from './media-cards-section/media-cards-section.module';
import { MediaPanelSectionModule } from './media-panel-section/media-panel-section.module';
import { StaggeredSectionModule } from './staggered-section/staggered-section.module';
import { ThumbnailsSectionModule } from './thumbnails-section/thumnails-section.module';

@NgModule({
  declarations: [PageSectionComponent],
  imports: [
    IntroSectionModule,
    CarouselSectionModule,
    IndexCardsModule,
    MediaCardsSectionModule,
    MediaPanelSectionModule,
    StaggeredSectionModule,
    ThumbnailsSectionModule,
    BackgroundModule,
    BrSdkModule,
    CommonModule,
    FlexboxModule,
    GridModule,
    PaddingModule,
    SpacingModule,
    RouterModule,
  ],
  exports: [PageSectionComponent],
  entryComponents: [PageSectionComponent],
})

/**
 * Page Section Module
 */
export class PageSectionModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Page Section': PageSectionComponent,
    };
  }
}
